import { Dialog, Typography } from '@mui/material';

import CustomButton from 'components/CustomButton';

import { ModalRowContent, ModalWrapper } from './index.styled';

interface EditOrderModalProps {
  open: boolean;
  handleCloseModal: () => void;
}

const EditOrderModal = ({ open, handleCloseModal }: EditOrderModalProps) => (
  <Dialog
    open={open}
    onClose={handleCloseModal}
  >
    <ModalWrapper>
      <ModalRowContent>
        <Typography variant="h6">
          Edit Order
        </Typography>
        <CustomButton
          id="button-modal-void"
          color="primary"
          size="small"
          variant="contained"
        >
          Void
        </CustomButton>
        <CustomButton
          id="button-modal-return"
          color="primary"
          variant="contained"
          size="small"
        >
          Return
        </CustomButton>
        <CustomButton
          id="button-modal-edit"
          color="primary"
          variant="contained"
          size="small"
        >
          Edit Payments
        </CustomButton>
        <CustomButton
          id="button-modal-merge"
          size="small"
          color="primary"
          variant="contained"
        >
          Merge Orders
        </CustomButton>
        <CustomButton
          id="button-edit-order-modal"
          onClick={handleCloseModal}
          variant="outlined"
          size="small"
        >
          Close
        </CustomButton>
      </ModalRowContent>
    </ModalWrapper>
  </Dialog>
);

export default EditOrderModal;
